import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Switch } from '../components/ui/switch';
import { Label } from '../components/ui/label';
import { Separator } from '../components/ui/separator';
import useThemeStore from '../stores/themeStore';
import useAuthStore from '../stores/authStore';

export default function SettingsPage() {
  const { theme, toggleTheme } = useThemeStore();
  const { user } = useAuthStore();

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <p className="text-[10px] font-heading uppercase tracking-[0.2em] text-[#3D1F6E] dark:text-[#A78BFA] font-semibold mb-1">
          Preferences
        </p>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight font-heading">Settings</h1>
      </div>

      <Card className="bg-card border-border card-shadow">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-heading font-semibold text-[#3D1F6E] dark:text-[#A78BFA]">Profile</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <Row label="Name" value={user?.name} />
          <Separator />
          <Row label="Role" value={user?.role} capitalize />
          <Separator />
          <Row label="College" value={user?.college_name} />
          <Separator />
          <Row label="User ID" value={user?.user_id} mono />
        </CardContent>
      </Card>

      <Card className="bg-card border-border card-shadow">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-heading font-semibold text-[#3D1F6E] dark:text-[#A78BFA]">Appearance</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-between">
            <Label htmlFor="dark-mode" className="text-sm">Dark mode</Label>
            <Switch
              id="dark-mode"
              checked={theme === 'dark'}
              onCheckedChange={toggleTheme}
              data-testid="settings-dark-mode-toggle"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

function Row({ label, value, capitalize, mono }) {
  return (
    <div className="flex justify-between items-center py-0.5">
      <span className="text-sm text-muted-foreground">{label}</span>
      <span className={`text-sm font-medium ${capitalize ? 'capitalize' : ''} ${mono ? 'font-mono text-xs' : ''}`}>
        {value || '—'}
      </span>
    </div>
  );
}
